import jsPDF from "jspdf";

function safe(value) {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
}

function line(doc, y) {
  doc.setLineWidth(0.5);
  doc.line(40, y, 570, y);
}

export default function downloadTicketPdf(ticket) {
  const payment = ticket?.payments?.[0];
  const exhibitions = Array.isArray(ticket?.exhibitions) ? ticket.exhibitions : [];

  const doc = new jsPDF("portrait", "pt", "a4");

  doc.setFontSize(22);
  doc.text("Ticket Summary", 40, 45);
  line(doc, 60);

  doc.setFontSize(12);

  const rows = [
    ["Museum", ticket?.museum_name],
    ["Ticket No.", ticket?.ticket_no],
    ["State", ticket?.state],
    ["Payment Status", payment?.status],
    ["Ticket Type (API)", ticket?.ticket_type_name],
    ["Ticket Type (Legacy)", ticket?.ticket_type_legacy],
    ["Visitor Type", ticket?.visitor_type_name],
    ["Nationality", ticket?.nationality_other ? `${ticket?.nationality} (${ticket?.nationality_other})` : ticket?.nationality],
    ["Visitors", ticket?.no_of_visitor],
    ["Validity", ticket?.validity],
    ["Guide", ticket?.guide_detail?.name || ticket?.guide_name],
    ["Payment Due", ticket?.payment_due],
    ["Payment Type", ticket?.payment_type],
    ["Transaction No.", ticket?.transaction_no],
    ["Payment Reference", payment?.reference_no],
    ["Payment Mode", payment?.mode],
    ["Payment Amount", payment?.amount],
  ];

  let y = 90;
  rows.forEach(([label, value]) => {
    doc.text(`${label}:`, 40, y);
    doc.text(safe(value), 220, y);
    y += 18;
  });

  if (exhibitions.length > 0) {
    y += 8;
    doc.text("Exhibitions:", 40, y);
    y += 18;
    exhibitions.forEach((x) => {
      doc.text(`- ${safe(x?.name)}`, 60, y);
      y += 16;
    });
  }

  doc.save("Ticket_Summary.pdf");
}
